import { CoatRackIcon } from './CoatRackIcon';

/**
 * author: Michael Richins
 * id 21D89E60-3522-4F1F-A1D2-60E67B2C9552
 * name coat-rack
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/coat-rack.svg
 * tags
 * - Home Automation 
 * - Clothing 
 */
export const FoyerIcon = CoatRackIcon;
export default FoyerIcon